import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AccountService } from 'app/shared';
import { SystemService } from '../system.service';
import { ProfileService } from '../profile.service';
import { LayoutService } from '../layout.service';
import { NavigationComponent } from '../navigation/navigation.component';



@Component({
  selector: 'app-narrow-navigation',
  templateUrl: './narrow-navigation.component.html',
  styleUrls: ['./narrow-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'd-block'
  }
})
export class NarrowNavigationComponent extends NavigationComponent implements OnInit {
  constructor(
    protected changeDetector: ChangeDetectorRef,
    public router: Router,
    public system: SystemService,
    public layoutService: LayoutService,
    public accountService: AccountService,
    public profileService: ProfileService
  ) {
    super(changeDetector, router, system, layoutService, accountService, profileService);
  }
}
